module.exports = __webpack_public_path__ + "static/trust-prev-e59002322d47f3cfc22b908bf8fcdeed.jpg";